import React from "react";

import auth from "./helpers/auth";

class App extends React.Component {
  state = {
    loggedIn: auth.loggedIn(),
  };

  componentWillMount() {
    auth.onChange = this.updateAuth;
    document.getElementById("loader").outerHTML = "";
  }

  updateAuth = (loggedIn) => {
    this.setState({
      loggedIn: loggedIn,
    });
  };

  render() {
    return <React.Fragment>{this.props.children}</React.Fragment>;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js